export function formatDate(date: Date) {
  const day = date.getDate()
  const month = date.getMonth() + 1
  const year = date.getFullYear()

  return `${day}/${month}/${year}`
}

/**
 * Format a date using i18n for localization
 * @param date The date to format
 * @param options Intl.DateTimeFormatOptions to customize the output
 * @returns Formatted date string based on current locale
 */
export function formatDateWithI18n(
  date: Date | string,
  options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  },
) {
  if (!date)
    return ''

  // Convert string to Date if needed
  const dateObj = typeof date === 'string' ? new Date(date) : date

  // Get the current locale from i18n
  const locale = 'fr-FR'

  return new Intl.DateTimeFormat(locale, options).format(dateObj)
}
